import axios from '../shared/axios';
import Lang from 'lang.js';

window.axios = axios;

window.lang = new Lang({
    locale: document.documentElement.lang,
    messages: Jobtoolz.translations
});

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'Accept-Language': window.lang.locale
};

if (
	(typeof Jobtoolz != 'undefined') &&
	(typeof Jobtoolz.api != 'undefined') &&
	(typeof Jobtoolz.api.token != 'undefined')
) {
	window.axios.defaults.headers.common.Authorization = 'Bearer ' + Jobtoolz.api.token;
}
